module.exports = __webpack_public_path__ + "src/img/banana/0.png?16becd4f6ebc9e698e2aa5bc726e8879";


//////////////////
// WEBPACK FOOTER
// ./src/img/banana/0.png
// module id = 166
// module chunks = 0